import { io } from 'socket.io-client'
import { getAuthToken } from 'utils/auth'
import { getNewAccessToken } from 'utils/io/http/axios'

// eslint-disable-next-line import/no-mutable-exports
export const AIAssistantSocketClient = io(
  process.env['REACT_APP_COLLECTIONS_AGENT_SOCKET_URL'],
  {
    autoConnect: false,
    reconnection: true,
    transports: ['websocket'],
    query: {
      token: getAuthToken(),
    },
  }
)

export const reconnectWebsocket = async (callback: () => void) => {
  AIAssistantSocketClient.disconnect()

  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  AIAssistantSocketClient.io.opts.query = {
    token: (await getNewAccessToken()) ?? getAuthToken(),
  }

  AIAssistantSocketClient.connect()

  callback()
}
